import RasConfigurazionePostiLettoPianiListPage from "./pages/RasConfigurazionePostiLettoPianiListPage.vue";
import RasConfigurazionePostiLettoPianiEditPage from "./pages/RasConfigurazionePostiLettoPianiEditPage.vue";
import RasConfigurazionePostiLettoPianiViewPage from "./pages/RasConfigurazionePostiLettoPianiViewPage.vue";
import RasConfigurazionePostiLettoStanzeListPage from "./pages/RasConfigurazionePostiLettoStanzeListPage.vue";
import RsaConfigurazioneDiariListPage from "./pages/RsaConfigurazioneDiariListPage.vue";
import RsaConfigurazioneDiariEditPage from "./pages/RsaConfigurazioneDiariEditPage.vue";
import RsaConfigurazioneProfiliLisListPage from "./pages/RsaConfigurazioneProfiliLisListPage.vue";
import RsaConfigurazioneProfiliLisViewPage from "./pages/RsaConfigurazioneProfiliLisViewPage.vue";
import RsaConfigurazioneProfiliLisEditPage from "./pages/RsaConfigurazioneProfiliLisEditPage.vue";
import RsaConfigurazioneAreeListPage from "./pages/RsaConfigurazioneAreeListPage.vue";
import RsaConfigurazioneAreeEditPage from "./pages/RsaConfigurazioneAreeEditPage.vue";
import RsaConfigurazioneAreeViewPage from "./pages/RsaConfigurazioneAreeViewPage.vue";
import RsaConfigurazioneAttivitaListPageResidenzialeListPage from "./pages/RsaConfigurazioneAttivitaResidenzialeListPage.vue";
import RsaConfigurazioneAttivitaEditPage from "./pages/RsaConfigurazioneAttivitaEditPage.vue";
import RsaConfigurazioneAttivitaViewPage from "./pages/RsaConfigurazioneAttivitaViewPage.vue";
import RsaConfigurazioneLaboratoriListPage from "./pages/RsaConfigurazioneLaboratoriListPage.vue";
import RsaConfigurazioneLaboratoriEditPage from "./pages/RsaConfigurazioneLaboratoriEditPage.vue";
import RsaConfigurazioneSettingsViewPage from "./pages/RsaConfigurazioneSettingsViewPage.vue";
import RsaConfigurazioneSettingsListPage from "./pages/RsaConfigurazioneSettingsListPage.vue";
import RsaConfigurazioneTipoPrestazioniListPage from "./pages/RsaConfigurazioneTipoPrestazioniListPage.vue";
import RsaConfigurazioneTipoPrestazioniViewPage from "./pages/RsaConfigurazioneTipoPrestazioniViewPage.vue";
import RsaConfigurazionePrestazioniAmbulatorialiListPage from "./pages/RsaConfigurazionePrestazioniAmbulatorialiListPage.vue";
import RsaConfigurazioneSpeseExtraListPage from "./pages/RsaConfigurazioneSpeseExtraListPage.vue";
import RsaPaiRuoliListPage from "./pages/RsaPaiRuoliListPage.vue";
import RsaPaiSpecializzazioneListPage from "./pages/RsaPaiSpecializzazioneListPage.vue";
import RsaConfigurazioneDizionarioListPage from "./pages/RsaConfigurazioneDizionarioListPage.vue";
import RsaConfigurazioneParametriVitaliListPage from "./pages/RsaConfigurazioneParametriVitaliListPage.vue";
import RsaConfigurazioneImpegnativaGruppoPrestazioniListPage from "./pages/RsaConfigurazioneImpegnativaGruppoPrestazioniListPage.vue";
import RsaConfigurazioneTurniListPage from "./pages/RsaConfigurazioneTurniListPage.vue";
import RsaConfigurazionePostiLettoStanzeViewPage from "./pages/RsaConfigurazionePostiLettoStanzeViewPage.vue";
import RsaConfigurazionePostiLettoLettiViewPage from "./pages/RsaConfigurazionePostiLettoLettiViewPage.vue";
import RsaConfigurazioneTipoImpegnativaListPage from "./pages/RsaConfigurazioneTipoImpegnativaListPage.vue";
import RsaConfigurazioneMenuPazienteListPage from "./pages/RsaConfigurazioneMenuPazienteListPage.vue";
import RsaConfigurazioneAttivitaDomiciliareListPage from "./pages/RsaConfigurazioneAttivitaDomiciliareListPage.vue";
import RsaConfigurazioneLaboratoriViewPage from "./pages/RsaConfigurazioneLaboratoriViewPage.vue";
// import RsaConfigurazioneLaboratoriRepartiViewPage from "./pages/RsaConfigurazioneLaboratoriRepartiViewPage.vue";
import RsaConfigurazioneAggiornamentoTariffaListPage from "./pages/RsaConfigurazioneAggiornamentoTariffaListPage.vue";
import RsaConfigurazioneSettingLivelliListPage from "./pages/RsaConfigurazioneSettingLivelliListPage.vue";
import RsaConfigurazioneSettingLivelliEditPage from "./pages/RsaConfigurazioneSettingLivelliEditPage.vue";
import RsaConfigurazioneStrutturaProvenienzaListPage from "./pages/RsaConfigurazioneStrutturaProvenienzaListPage.vue";
import RsaConfigurazioneStrutturaProvenienzaEditPage from "./pages/RsaConfigurazioneStrutturaProvenienzaEditPage.vue";
import RsaConfigurazioneStrutturaProvenienzaViewPage from "./pages/RsaConfigurazioneStrutturaProvenienzaViewPage.vue";
export default {
    RsaConfigurazioneAggiornamentoTariffaListPage,
    RsaConfigurazioneTurniListPage,
    RsaConfigurazioneImpegnativaGruppoPrestazioniListPage,
    RsaConfigurazioneParametriVitaliListPage,
    RsaConfigurazioneDizionarioListPage,
    RsaPaiSpecializzazioneListPage,
    RsaPaiRuoliListPage,
    RsaConfigurazionePrestazioniAmbulatorialiListPage,
    RsaConfigurazioneTipoPrestazioniListPage,
    RsaConfigurazioneTipoPrestazioniViewPage,
    RsaConfigurazioneSettingsListPage,
    RsaConfigurazioneSettingsViewPage,
    RasConfigurazionePostiLettoPianiListPage,
    RasConfigurazionePostiLettoPianiEditPage,
    RasConfigurazionePostiLettoPianiViewPage,
    RasConfigurazionePostiLettoStanzeListPage,
    /* RasConfigurazionePostiLettoStanzeEditPage, */
    RsaConfigurazioneDiariListPage,
    RsaConfigurazioneDiariEditPage,
    RsaConfigurazioneProfiliLisListPage,
    RsaConfigurazioneProfiliLisViewPage,
    RsaConfigurazioneProfiliLisEditPage,
    RsaConfigurazioneAreeListPage,
    RsaConfigurazioneAreeEditPage,
    RsaConfigurazioneAreeViewPage,
    RsaConfigurazioneAttivitaListPageResidenzialeListPage,
    RsaConfigurazioneAttivitaEditPage,
    RsaConfigurazioneAttivitaViewPage,
    RsaConfigurazioneLaboratoriListPage,
    RsaConfigurazioneLaboratoriEditPage,
    RsaConfigurazioneSpeseExtraListPage,
    RsaConfigurazionePostiLettoStanzeViewPage,
    RsaConfigurazionePostiLettoLettiViewPage,
    RsaConfigurazioneTipoImpegnativaListPage,
    RsaConfigurazioneMenuPazienteListPage,
    RsaConfigurazioneAttivitaDomiciliareListPage,
    RsaConfigurazioneLaboratoriViewPage,
    // RsaConfigurazioneLaboratoriRepartiViewPage,
    RsaConfigurazioneSettingLivelliListPage,
    RsaConfigurazioneSettingLivelliEditPage,
    RsaConfigurazioneStrutturaProvenienzaListPage,
    RsaConfigurazioneStrutturaProvenienzaEditPage,
    RsaConfigurazioneStrutturaProvenienzaViewPage,
};
